import React from "react";
import "./style.css";
import { FaGithub } from "react-icons/fa";
import { IoLogoFirebase } from "react-icons/io5";
import { TbBrandFlutter } from "react-icons/tb";
import { SiDart } from "react-icons/si";
import { IoLogoAndroid } from "react-icons/io";
import { FaCode } from "react-icons/fa";
import { FaRegLightbulb } from "react-icons/fa";
import { FaGooglePlay } from "react-icons/fa";
const SkillsComponent = () => {
  const skills = [
    {
      icon: TbBrandFlutter,
      name: "Flutter",
    },
    {
      icon: SiDart,
      name: "Dart",
    },
    {
      icon: IoLogoFirebase,
      name: "Firebase",
    },

    {
      icon: FaGithub,
      name: "Github",
    },
    {
      icon: IoLogoAndroid,
      name: "Android",
    },
    {
      icon: FaCode,
      name: "Clean architecture",
    },
    {
      icon: FaRegLightbulb,
      name: "SM (Provider, Bloc)",
    },
    {
      icon: FaGooglePlay,
      name: "upload app",
    },
  ];

  return (
    <div className="skills-container" data-aos="fade-up">
      <div className="skills-header">
        <h2>Skills</h2>
        <p>My technical level</p>
      </div>
      <div className="skills">
        {skills.map((skill, index) => {
          return (
            <div className="iconbox" key={index}>
              <div className="skill-icon">
                <skill.icon />
              </div>
              <p>{skill.name}</p>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default SkillsComponent;
